<div class="asset-select">
  <input class="field__input asset-select__search" type="search" [attr.aria-label]="'COMMON.SEARCH' | translate" [placeholder]="'COMMON.SEARCH' | translate" (input)="search($any($event.target).value)" />
  <select class="field__input asset-select__list" [attr.aria-label]="'ASSET_CHARGES.SELECT_ASSET' | translate" (change)="pick($any($event.target).value)">
    <option value="">{{ (allowNone() ? 'ASSET_CHARGES.NO_ASSET' : 'ASSET_CHARGES.SELECT_ASSET') | translate }}</option>
    @for (asset of items(); track asset.id) {
      <option [value]="asset.id" [selected]="asset.id === current()">{{ label(asset) }}</option>
    }
  </select>
</div>
